import { createPermission } from '@backstage/plugin-permission-common';

export const DEFAULT_LANDING_RESOURCE_TYPE = 'default-landing';

export const defaultLandingReadPermission = createPermission({
  name: 'landing.default.read',
  attributes: { action: 'read' },
});

export const defaultLandingPermissions = [defaultLandingReadPermission];
